export default {
  uploadImage: 'Subir imagen',
  uploadImageByUrl: 'Insertar URL',
  uploading: 'Subiendo...',
  imageFileSizeError: 'La imagen no puede pesar más de 10mb',
  imageUploadError: 'Hubo un error al subir la imagen. Intente nuevamente',
  imageExtensionError: 'Solo puedes subir archivos png, jpg, o jpeg',
  urlVideo: 'Video',
  invalidUrl: 'URL inválida',
  characters: 'caracteres',
  words: 'palabras',
  submitImageUrl: 'Insertar imagen',
  submitVideoUrl: 'Insertar video',
  submitLinkUrl: 'Insertar enlace',
  placeholders: {
    image: 'Insertar URL de la imagen',
    video: 'Insertar video',
    link: 'Insertar enlace'
  },
  menuItems: {
    heading: 'Tamaño',
    bold: 'Negrita',
    italic: 'Cursiva',
    strike: 'Tachar',
    underline: 'Subrayado',
    removeMarks: 'Borrar formato',
    unorderedList: 'Lista con viñetas',
    orderedList: 'Lista enumerada',
    quote: 'Cita',
    alignLeft: 'Alinear a la izquierda',
    alignCenter: 'Centrar',
    alignRight: 'Alinear a la derecha',
    alignJustify: 'Justificar',
    link: 'Agregar enlace',
    removeLink: 'Quitar enlace',
    image: 'Agregar imagen',
    video: 'Agregar video',
    undo: 'Deshacer',
    redo: 'Rehacer',
    table: 'Tabla',
    preview: 'Vista previa'
  },
  tableMenu: {
    insertTable: 'Insertar tabla',
    insertColumnBefore: 'Insertar columna antes',
    insertColumnAfter: 'Insertar columna después',
    deleteColumn: 'Borrar columna',
    insertRowBefore: 'Insertar fila antes',
    insertRowAfter: 'Insertar fila después',
    deleteRow: 'Borrar fila',
    mergeCells: 'Unir celdas',
    splitCell: 'Dividir celda',
    toggleHeaderColumn: 'Alternar columna de cabecera',
    toggleHeaderRow: 'Alternar fila de cabecera',
    toggleHeaderCell: 'Alternar celda de cabecera',
    deleteTable: 'Borrar tabla'
  }
}

export const en = {
  uploadImage: 'Upload image',
  uploadImageByUrl: 'Insert URL',
  uploading: 'Uploading...',
  imageFileSizeError: 'Image can\'t be larger than 10mb',
  imageUploadError: 'Something went wrong uploading the image. Please try again',
  imageExtensionError: 'You can only upload png, jpg, or jpeg files',
  urlVideo: 'Video',
  invalidUrl: 'Invalid URL',
  characters: 'characters',
  words: 'words',
  submitImageUrl: 'Insert image',
  submitVideoUrl: 'Insert video',
  submitLinkUrl: 'Insert link',
  placeholders: {
    image: 'Insert image URL',
    video: 'Insert video',
    link: 'Insert link'
  },
  menuItems: {
    heading: 'Heading',
    bold: 'Bold',
    italic: 'Italic',
    strike: 'Strike-through',
    underline: 'Underline',
    removeMarks: 'Clear formatting',
    unorderedList: 'Bulleted list',
    orderedList: 'Numbered list',
    quote: 'Quote',
    alignLeft: 'Align left',
    alignCenter: 'Center',
    alignRight: 'Align right',
    alignJustify: 'Justify',
    link: 'Add link',
    removeLink: 'Remove link',
    image: 'Add image',
    video: 'Add video',
    undo: 'Undo',
    redo: 'Redo',
    table: 'Table',
    preview: 'Preview'
  },
  tableMenu: {
    insertTable: 'Insert table',
    insertColumnBefore: 'Insert column to the left',
    insertColumnAfter: 'Insert column to the right',
    deleteColumn: 'Delete column',
    insertRowBefore: 'Insert row above',
    insertRowAfter: 'Insert row below',
    deleteRow: 'Delete row',
    mergeCells: 'Merge cells',
    splitCell: 'Split cell',
    toggleHeaderColumn: 'Toggle header column',
    toggleHeaderRow: 'Toggle header row',
    toggleHeaderCell: 'Toggle header cell',
    deleteTable: 'Delete table'
  }
}

export const ca = {
  uploadImage: 'Subir imagen',
  uploadImageByUrl: 'Insertar URL',
  uploading: 'Subiendo...',
  imageFileSizeError: 'La imagen no puede pesar más de 10mb',
  imageUploadError: 'Hubo un error al subir la imagen. Intente nuevamente',
  imageExtensionError: 'Solo puedes subir archivos png, jpg, o jpeg',
  urlVideo: 'Video',
  invalidUrl: 'URL no vàlid',
  characters: 'caracteres',
  words: 'palabras',
  submitImageUrl: 'Insertar imagen',
  submitVideoUrl: 'Insertar video',
  submitLinkUrl: 'Insertar enlace',
  placeholders: {
    image: 'Insertar URL de la imagen',
    video: 'Insertar video',
    link: 'Insertar enlace'
  },
  menuItems: {
    heading: 'Mida',
    bold: 'Negreta',
    italic: 'Cursiva',
    strike: 'Ratllat',
    underline: 'Subratlla',
    removeMarks: 'Esborra el format',
    unorderedList: 'Llista de pics',
    orderedList: 'Llista numerada',
    quote: 'Cometes',
    alignLeft: 'Alinear a l\'esquerra',
    alignCenter: 'Centrar',
    alignRight: 'Alinear a la dreta',
    alignJustify: 'Justificar',
    link: 'Insereix un enlaç',
    removeLink: 'Treure un enlaç',
    image: 'Insereix una foto',
    video: 'Insereix un vídeo',
    undo: 'Desfés',
    redo: 'Refés',
    table: 'Taula',
    preview: 'Vista prèvia'
  },
  tableMenu: {
    insertTable: 'Insereix taula',
    insertColumnBefore: 'Insereix 1 columna a l\'esquerra',
    insertColumnAfter: 'Insereix 1 columna a la dreta',
    deleteColumn: 'Suprimeix la columna',
    insertRowBefore: 'Insereix 1 fila a sobre',
    insertRowAfter: 'Insereix 1 fila a sota',
    deleteRow: 'Suprimeix la fila',
    mergeCells: 'Separa les cel·les',
    splitCell: 'Divideix la cel·la',
    toggleHeaderColumn: 'Alternar columna de capçalera',
    toggleHeaderRow: 'Alternar fila de capçalera',
    toggleHeaderCell: 'Alternar cel·la de capçalera',
    deleteTable: 'Suprimeix la taula'
  }
}
